module.exports = __webpack_public_path__ + "media/images/official/about_comipla_image2-5103c25aa3429f28d9b338d34c7d0233.jpg";